import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _SubMacroProcess } from '../../../core/services/dataBean/EntityCatalog';
import { _ContractType, _HiringModality, _PaymentRequirement } from '../../../core/services/dataBean/EntityCatalogVdos';



interface Props {

    idSelector: number;
    onChange: any;
    label?: string;
}

export const ContractTypeEditor = ({ idSelector, onChange, label }: Props) => {

    const ContractType = useDataBean(_ContractType)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector)
        }
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])


    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(e);
    }

    const getLista = () => {
        ContractType.instance.getContractTypeCatalogPorPropiedad('State', 1, null).then(
            (resp) => {
                setLista(resp)
            }
        )
    }

    return (
        <>
            <label>{label ?? "Tipo Contrato"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>

                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDContractType} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}